import AllMilestones from '../Components/AllMilestones';
import CreateMilestone from '../Components/CreateMilestone';

export const MilestoneRoutes = [
  {
    Component: AllMilestones,
    path: "/all",
    exact: true,
    id: "dashboardMilestonesAll",
    routePath: "/dashboard/milestones/all",
    name: "All Milestones"
  },
  {
    Component: CreateMilestone,
    path: '/edit/:id',
    exact: true,
    id: 'dashboardMilestonesEdit',
  },
  {
    Component: CreateMilestone,
    path: "/create",
    exact: true,
    id: "dashboardMilestonesCreate",
    routePath: "/dashboard/milestones/create",
    name: "Create Milestone"
  }
];
